import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";

const EMPTY = { name: "", service_category: "", phone: "", upi_handle: "" };

export function QuickVendorDialog({ open, onOpenChange, projectId, projectName, onCreated }) {
  const [form, setForm] = useState(EMPTY);
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (open) { setForm(EMPTY); } }, [open]);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const save = async () => {
    if (!form.name.trim()) { toast.error("Enter the vendor name"); return; }
    setBusy(true);
    try {
      const r = await api.post("/vendors", { ...form, project_id: projectId });
      toast.success(`${r.data.name} added`);
      onCreated(r.data);
      onOpenChange(false);
    } catch (e) { toast.error(errMsg(e)); }
    finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="quick-vendor-dialog" className="max-w-md">
        <DialogHeader>
          <DialogTitle>Add vendor</DialogTitle>
          <DialogDescription>For {projectName || "this project"}. Add GSTIN, bank and address later on the Vendors page.</DialogDescription>
        </DialogHeader>
        <div className="grid gap-3 py-1">
          <div><Label>Vendor name</Label><Input data-testid="qv-name" autoFocus value={form.name} onChange={set("name")} onKeyDown={(e)=>{ if (e.key === "Enter") save(); }}/></div>
          <div><Label>Service / category <span className="text-muted-foreground">(optional)</span></Label><Input data-testid="qv-service" value={form.service_category} onChange={set("service_category")} placeholder="e.g. JCB Rental"/></div>
          <div className="grid grid-cols-2 gap-3">
            <div><Label>Phone <span className="text-muted-foreground">(optional)</span></Label><Input data-testid="qv-phone" inputMode="tel" value={form.phone} onChange={set("phone")}/></div>
            <div><Label>UPI handle <span className="text-muted-foreground">(optional)</span></Label><Input data-testid="qv-upi" value={form.upi_handle} onChange={set("upi_handle")}/></div>
          </div>
        </div>
        <DialogFooter>
          <Button data-testid="qv-cancel" variant="outline" onClick={() => onOpenChange(false)} disabled={busy}>Cancel</Button>
          <Button data-testid="qv-save" onClick={save} disabled={busy}>{busy ? "Adding…" : "Add & select"}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
